import { DataFactory } from 'n3';
import { parseTurtle, getOneMatchingQuad, NOTIFY, getAllMatchingQuads, getStorageDescription, getDescriptionResource } from '@janeirodigital/interop-utils';

class DiscoveryClient {
    constructor(authnFetch) {
        this.authnFetch = authnFetch;
        this.rdf = {
            contentType: 'text/turtle',
            parse: parseTurtle
        };
    }
    async findService(resourceUri, channelType) {
        const storageDescription = await this.fetchStorageDescription(resourceUri);
        const serviceNode = getOneMatchingQuad(storageDescription, null, NOTIFY.channelType, DataFactory.namedNode(channelType))?.subject;
        if (!serviceNode)
            return null;
        const features = getAllMatchingQuads(storageDescription, serviceNode, NOTIFY.feature).map(quad => quad.object.value);
        return {
            id: serviceNode.value,
            channelType,
            feature: features
        };
    }
    async fetchResource(resourceUri) {
        const response = await this.authnFetch(resourceUri, {
            headers: {
                'Accept': this.rdf.contentType
            }
        });
        if (response.status < 200 || response.status > 300) {
            throw Error(`Failed fetching resource: ${resourceUri}`);
        }
        return this.rdf.parse(await response.text(), response.url);
    }
    async discoverStorageDescription(resourceUri) {
        const response = await this.authnFetch(resourceUri, { method: 'head' });
        if (response.status < 200 || response.status > 300) {
            throw Error(`Failed fetching resource: ${resourceUri}`);
        }
        return getStorageDescription(response.headers.get('Link'));
    }
    async fetchStorageDescription(resourceUri) {
        const storageDescriptionUri = await this.discoverStorageDescription(resourceUri);
        return this.fetchResource(storageDescriptionUri);
    }
    async discoverDescriptionResource(resourceUri) {
        const response = await this.authnFetch(resourceUri, { method: 'head' });
        return getDescriptionResource(response.headers.get('Link'));
    }
    async fetchDescriptionResource(resourceUri) {
        const resourceDescriptionUri = await this.discoverDescriptionResource(resourceUri);
        return this.fetchResource(resourceDescriptionUri);
    }
}

export { DiscoveryClient };
//# sourceMappingURL=index.mjs.map
